import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

import { useConfig } from '../../../defaultConfig';

const TransactionDetailsSkeleton: React.FC = () => {
    const { featureToggles } = useConfig();
    return (
        <>
            <div className="transaction-details__receiver">
                <div>
                    <DarkSkeleton width={130} />
                </div>
                <div className="transaction-details__receiver-amount">
                    <DarkSkeleton width={200} height={40} />
                </div>
            </div>
            <div className="transaction-details__details">
                <div className="transaction-details__detail">
                    <div className="transaction-details__detail-label">
                        <DarkSkeleton width={40} />
                    </div>
                    <p className="transaction-details__detail-data">
                        <DarkSkeleton width={100} />
                    </p>
                </div>
                <div className="transaction-details__detail">
                    <div className="transaction-details__detail-label">
                        <DarkSkeleton width={40} />
                    </div>
                    <p className="transaction-details__detail-data">
                        <DarkSkeleton width={100} />
                    </p>
                </div>
                <div className="transaction-details__detail">
                    <div className="transaction-details__detail-label">
                        <DarkSkeleton width={50} />
                    </div>
                    <p className="transaction-details__detail-data">
                        <DarkSkeleton width={180} />
                    </p>
                </div>
                <div className="transaction-details__detail">
                    <div className="transaction-details__detail-label">
                        <DarkSkeleton width={40} />
                    </div>
                    <p className="transaction-details__detail-data">
                        <DarkSkeleton width={100} />
                    </p>
                </div>
                <div className="transaction-details__detail">
                    <div className="transaction-details__detail-label">
                        <DarkSkeleton width={50} />
                    </div>
                    <p className="transaction-details__detail-data">
                        <DarkSkeleton width={180} />
                    </p>
                </div>
                <div className="transaction-details__detail">
                    <div className="transaction-details__detail-label">
                        <DarkSkeleton width={40} />
                    </div>
                    <p className="transaction-details__detail-data">
                        <DarkSkeleton width="100%" />
                        <DarkSkeleton width={60} />
                    </p>
                </div>
            </div>
            {featureToggles.enableTransactionDetailsReservedFields && (
                <div className="transaction-details__attention_message_skeleton transaction-details__attention_message">
                    <DarkSkeleton />
                    <DarkSkeleton width="30%" />
                </div>
            )}
        </>
    );
};

export default TransactionDetailsSkeleton;
